import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 29px;
  height: 31px;
  color: ${({ color }: any) => color || '#18549A'};
`

const Qa = ({ color, title = 'Question and Answer', ...rest }: IconProps & { color?: string }) => (
  // @ts-expect-error
  <StyledIcon viewBox="0 0 29 31" color={color} title={title} {...rest}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M3.25 1h22.5C26.993 1 28 2.127 28 3.516v15.1c0 1.389-1.007 2.516-2.25 2.516H15.4l-8.1 7.046v-7.046H3.25c-1.243 0-2.25-1.127-2.25-2.517V3.516C1 2.126 2.007 1 3.25 1z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="square"
      />
      <text
        transform="translate(9 1)"
        fill="currentColor"
        fontFamily="Helvetica-Bold, Helvetica"
        fontSize={17}
        fontWeight="bold"
      >
        <tspan x={0} y={16}>
          {'?'}
        </tspan>
      </text>
    </g>
  </StyledIcon>
)

Qa.displayName = 'QuestionAnswer'
Qa.needsWork = true
export default Qa
